// =============================================================================
// features/sales/campaigns/operate/phone.ts — Formatação de exibição do
// telefone do lead reservado.
//
// LGPD (doc 17 §8.5) + contrato (`CampaignQueueLeadContextSchema`,
// packages/shared-schemas/src/sales-campaigns.ts): `lead.phone` é PII
// EXIBIDA POR DESIGN nesta tela — "exibido apenas ao vendedor dono do lease"
// — ao contrário do CRM (hooks/crm/types.ts `maskPhone`), que mascara porque
// ali é uma listagem/ficha geral. Aqui o número completo é o dado de
// trabalho: sem discagem automática ainda (F36-S07), o vendedor precisa do
// número inteiro para discar manualmente no próprio telefone. Mascarar
// quebraria a única finalidade desta tela.
// =============================================================================

/** Formata E.164 para exibição legível: "+5569999990000" → "+55 69 99999-0000". */
export function formatPhoneForDisplay(phoneE164: string): string {
  const digits = phoneE164.replace(/^\+/, '');
  if (digits.length < 10) return phoneE164;

  const country = digits.slice(0, 2);
  const area = digits.slice(2, 4);
  const rest = digits.slice(4);

  if (rest.length === 9) {
    return `+${country} ${area} ${rest.slice(0, 5)}-${rest.slice(5)}`;
  }
  if (rest.length === 8) {
    return `+${country} ${area} ${rest.slice(0, 4)}-${rest.slice(4)}`;
  }
  return `+${country} ${area} ${rest}`;
}
